import { render, staticRenderFns } from "./Auth0Callback.vue?vue&type=template&id=b11e6fe2&scoped=true&"
import script from "./Auth0Callback.vue?vue&type=script&lang=js&"
export * from "./Auth0Callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11e6fe2",
  null
  
)

export default component.exports